import type { AgentationProps } from 'agentation';
import type { FC } from 'react';
import { environment } from '../environments/environment';

/**
 * Mounts the Agentation visual feedback toolbar (https://agentation.com) in
 * development builds only. The toolbar is a React component, so React is
 * loaded lazily here and never ships in the initial bundle.
 *
 * Annotations are posted to the local agentation-mcp server (port 4747),
 * where Claude Code picks them up via MCP (see .mcp.json).
 */
export async function initAgentation(): Promise<void> {
  if (environment.production) {
    return;
  }

  const [{ Agentation }, React, { createRoot }] = await Promise.all([
    import('agentation'),
    import('react'),
    import('react-dom/client'),
  ]);

  const container = document.createElement('div');
  container.id = 'agentation-root';
  document.body.appendChild(container);

  // The toolbar defaults to the bottom-right corner and right-aligns its
  // content inside a fixed-width wrapper — flip both to sit bottom-left.
  // Also lift the dev widgets (Agentation toolbar + TanStack Query devtools)
  // above the CDK dialog overlay so they stay usable while a dialog is open.
  const style = document.createElement('style');
  style.textContent = `
    [data-agentation-toolbar].agentation-bottom-left {
      left: 1.25rem !important;
      right: auto !important;
    }
    [data-agentation-toolbar].agentation-bottom-left > * {
      margin-left: 0 !important;
      margin-right: auto !important;
      align-self: flex-start !important;
    }
    [data-agentation-toolbar],
    .tsqd-parent-container {
      z-index: 2147483600 !important;
    }
  `;
  document.head.appendChild(style);

  // The component declares its props as optional, which trips up
  // createElement's overload inference — retype it explicitly.
  const AgentationComponent = Agentation as FC<AgentationProps>;

  createRoot(container).render(
    React.createElement(AgentationComponent, {
      endpoint: 'http://localhost:4747',
      className: 'agentation-bottom-left',
    }),
  );
}
